import React, { useState, useEffect } from "react";
// Substituindo react-icons por lucide-react que é nativo do ambiente
import { Copy, MoreVertical, Edit3, Trash2 } from "lucide-react";
import Loader from "../../../../../components/Loader";
import useAuth from "../../../../../components/hooks/useAuth";

const GrupoItem = ({ idx, el, marcados, setMarcados, handleCopiarLink, setStModalAlterarGrupo, loadGroupRequest }) => {
    const [menuAberto, setMenuAberto] = useState(null);
    const [loading, setLoading] = useState(false);
    const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();

    // Lógica para detectar mobile via JS para estilos inline
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const updateFullishInvite = async (is_full) => {

        setLoading(true);
        try {
            let response = await postApi("/api/v1/campaign/groups/update/invite_fullish/" + is_full + "/" + el.id, {
            });
        } catch (error) {
            window.alert("Erro ao processar associação:", error);
            // Aqui você pode tratar o erro (ex: toast de aviso)
        } finally {
            loadGroupRequest();
            setLoading(false);
        }
    }

    return (
        <div key={idx} style={{
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            padding: isMobile ? "12px" : "16px 18px",
            display: "flex",
            flexDirection: "column",
            gap: 12,
            position: "relative",
            width: "100%",
            boxSizing: "border-box",
            transition: "all 0.2s ease"
        }}>
            {loading && <Loader />}

            {/* Linha Principal - Cabeçalho */}
            <div style={{
                display: "flex",
                alignItems: isMobile ? "flex-start" : "center",
                gap: isMobile ? 10 : 16,
                flexWrap: "wrap",
                width: "100%",
                position: "relative"
            }}>
                {/* Checkbox e Avatar */}
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <input
                        type="checkbox"
                        checked={marcados.includes(idx)}
                        onChange={e => {
                            if (e.target.checked) {
                                setMarcados([...marcados, idx]);
                            } else {
                                setMarcados(marcados.filter(id => id !== idx));
                            }
                        }}
                        style={{ width: 20, height: 20, cursor: "pointer", accentColor: "#51a197" }}
                    />
                    <div style={{
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        background: "#51a197",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        minWidth: 44,
                        minHeight: 44,
                        border: "2px solid #f0f7f6"
                    }}>
                        <img
                            src={el.picture_url || "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=100&q=80"}
                            alt={el.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                </div>

                {/* Nome do grupo */}
                <div style={{
                    fontWeight: "700",
                    fontSize: isMobile ? 16 : 18,
                    color: "#005c53",
                    flex: 1,
                    minWidth: isMobile ? "150px" : "auto",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>
                    {el.name} <span style={{ fontWeight: "400", fontSize: 13, color: "#8696a0", marginLeft: 4 }}>#{el.position}</span>
                </div>

                {/* Ações (Select e Botões) */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    width: isMobile ? "100%" : "auto",
                    justifyContent: isMobile ? "space-between" : "flex-end",
                    marginTop: isMobile ? 8 : 0,
                    borderTop: isMobile ? "1px solid #f8fafc" : "none",
                    paddingTop: isMobile ? 12 : 0
                }}>
                    <select
                        value={el.is_full}
                        onChange={e => updateFullishInvite(e.target.value)}
                        style={{
                            background: el.is_full ? "#51a197" : "#e74c3c",
                            color: "#fff",
                            borderRadius: 8,
                            padding: "6px 12px",
                            fontWeight: "700",
                            fontSize: 13,
                            minWidth: isMobile ? "110px" : 120,
                            textAlign: "center",
                            border: "none",
                            cursor: "pointer",
                            outline: "none"
                        }}
                        disabled={loading}
                    >
                        <option value={true}>Cheio: SIM</option>
                        <option value={false}>Cheio: NÃO</option>
                    </select>

                    <button
                        onClick={() => handleCopiarLink(el.invite_url)}
                        style={{
                            background: "#f1f5f9",
                            border: "none",
                            borderRadius: 8,
                            color: (!el.invite_enabled || el.is_full) ? "#dbdbdb" : "#475569",
                            padding: "8px 12px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: 13,
                            gap: 6,
                            transition: "background 0.2s"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#e2e8f0"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "#f1f5f9"}
                        disabled={!el.invite_enabled || el.is_full}
                    >
                        <Copy size={14} />
                        {isMobile ? "" : "Copiar"}
                    </button>

                    <div style={{ position: "relative" }}>
                        <button
                            onClick={() => setMenuAberto(menuAberto === idx ? null : idx)}
                            style={{
                                background: "transparent",
                                border: "none",
                                color: "#94a3b8",
                                cursor: "pointer",
                                padding: 8,
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "50%"
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "#f8fafc"}
                            onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                        >
                            <MoreVertical size={20} />
                        </button>
                        {menuAberto === idx && (
                            <div style={{
                                position: "absolute",
                                top: 40,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #e2e8f0",
                                borderRadius: 10,
                                boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                                zIndex: 100,
                                minWidth: 160,
                                padding: 4,
                                animation: "fadeIn 0.2s ease"
                            }}>
                                <button
                                    style={btnMenuEstilo}
                                    onClick={() => { setMenuAberto(null); setStModalAlterarGrupo(el.id); }}
                                >
                                    <Edit3 size={14} /> Editar
                                </button>
                                <button
                                    style={{ ...btnMenuEstilo, color: "#ef4444" }}
                                    onClick={() => setMenuAberto(null)}
                                >
                                    <Trash2 size={14} /> Remover
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Estatísticas Detalhadas */}
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: isMobile ? 8 : 20,
                marginLeft: isMobile ? 0 : 76,
                fontSize: 13,
                color: "#64748b",
                background: isMobile ? "#f8fafc" : "transparent",
                padding: isMobile ? "10px" : 0,
                borderRadius: 10,
                border: isMobile ? "1px solid #f1f5f9" : "none"
            }}>
                <div style={infoItem}>Acessos: <b style={{ color: "#334155" }}>{el.access_count}</b></div>
                <div style={infoItem}>Únicos: <b style={{ color: "#334155" }}>{el.access_unique_count} / {el.max_members}</b></div>|
                <div style={infoItem}>Cliques: <b style={{ color: "#334155" }}>{el.click_count}</b></div>
                <div style={infoItem}>Únicos: <b style={{ color: "#334155" }}>{el.click_unique_count}</b></div>
                <div style={infoItem}>Participantes: <b style={{ color: "#334155" }}>{el.qtd_members}</b></div>
            </div>

            <style>
                {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
            </style>
        </div>
    );
};

const infoItem = {
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: 4
};

const btnMenuEstilo = {
    background: "none",
    border: "none",
    color: "#334155",
    padding: "10px 12px",
    textAlign: "left",
    cursor: "pointer",
    fontWeight: "600",
    width: "100%",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: 8,
    borderRadius: 6,
    transition: "background 0.2s"
};

export default GrupoItem;